module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_time-b139ed675fdbdca56f0d73121f36f836.png";